import { BaseApiClient, JSONApiResponse } from "./base";
import { TenantConfig } from "./dto";

const TENANTS_URL = "/api/frontend-configuration";

export enum Application {
  BACKOFFICE = "backoffice",
  GUEST_JOURNEY = "guest-journey",
  MONITORING = "monitoring"
}

class TenantApiClient extends BaseApiClient {
  async getTenants(application: Application) {
    const response = await this.fetchApi(TENANTS_URL + "/" + application, {
      // send the real window header (Host header is overwritten by setupProxyheader)
      headers: {
        "window-location": window.location.href
      }
    });
    return new JSONApiResponse<TenantConfig>(response).value();
  }
}

export const TenantApi = new TenantApiClient();
